const featuresData = [
  {
    icon: 'ri-speed-up-line',
    title: '高清流畅播放',
    desc: '全网吃瓜视频高清画质，自适应带宽，即点即看无需等待缓冲，给你最流畅的在线观看体验',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日实时更新',
    desc: '51吃瓜、91吃瓜等热门源24小时不间断更新，黑料吃瓜第一时间推送，绝不让你错过任何新瓜',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全无广告',
    desc: '观看全程无弹窗广告、无恶意跳转，严格筛选内容来源，保障你的在线吃瓜观看安全',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端同步观看',
    desc: '支持手机、平板、电脑全设备访问，随时随地打开浏览器就能在线观看吃瓜视频',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-3">
          <div className="w-8 h-8 rounded-lg bg-secondary-500 flex items-center justify-center">
            <i className="ri-star-line text-background-50 text-lg"></i>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">平台特色</h2>
        </div>
        <p className="text-foreground-500 text-sm mb-8 md:mb-10">为什么千万吃瓜群众选择我们？四大优势让你吃瓜更尽兴</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {featuresData.map((item, i) => (
            <div key={i} className="p-6 rounded-xl bg-background-50 text-center group">
              <div className="w-14 h-14 rounded-2xl bg-secondary-100 flex items-center justify-center mx-auto mb-4 group-hover:bg-secondary-200 transition-colors">
                <i className={`${item.icon} text-secondary-600 text-2xl`}></i>
              </div>
              <h3 className="font-heading font-bold text-foreground-900 text-base mb-2">{item.title}</h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}